import { render, staticRenderFns } from "./LeadPerfilApp.vue?vue&type=template&id=160dd92c"
import script from "./LeadPerfilApp.vue?vue&type=script&lang=js"
export * from "./LeadPerfilApp.vue?vue&type=script&lang=js"
import style0 from "./LeadPerfilApp.vue?vue&type=style&index=0&id=160dd92c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports